import { render, staticRenderFns } from "./product-card-rating.vue?vue&type=template&id=7da6cf50"
import script from "./product-card-rating.vue?vue&type=script&lang=js"
export * from "./product-card-rating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports